"use client";
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import clsx from "clsx";
import { animate } from "framer-motion";
import React, { useEffect, useRef } from "react";
export function Facts(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "my-10 flex flex-col flex-wrap lg:gap-8 md:flex-row"
    }, props.facts.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "box box-border w-full text-center md:w-1/2 mb-9 lg:mb-0 lg:w-auto lg:flex-1"
        }, /*#__PURE__*/ React.createElement(FactsItem, _extends({}, item)));
    }))));
}
function FactsItem(param) {
    var prefix = param.prefix, value = param.value, suffix = param.suffix, description = param.description, symbol = param.symbol;
    var Icon = symbol ? IconMap[symbol] : undefined;
    var nodeRef = useRef(null);
    var suffixGreaterThan1 = suffix ? (suffix === null || suffix === void 0 ? void 0 : suffix.length) > 1 : false;
    var number = value.includes(".") ? parseFloat(value) : parseInt(value);
    useEffect(function() {
        var node = nodeRef.current;
        if (!isNaN(number)) {
            var controls = animate(0, number, {
                duration: number % 1 === 0 ? 2 : 0,
                onUpdate: function onUpdate(value) {
                    if (node) {
                        node.textContent = value.toFixed(number % 1 === 0 ? 0 : 1);
                    }
                }
            });
            return function() {
                return controls.stop();
            };
        }
    }, [
        number
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "text-center relative inline-block lg:w-full"
    }, Icon, /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative font-medium whitespace-nowrap", {
            "top-[30px] xxl:top-[25px]": symbol === "Square",
            "top-2 xxl:top-0": symbol === "Squiggle",
            "leading-none mb-5 mt-8": !suffixGreaterThan1
        })
    }, value ? /*#__PURE__*/ React.createElement("h3", {
        className: clsx("with-number", {
            "inline text-[3.3rem] xxl:text-[4rem] mt-0": !suffixGreaterThan1,
            "text-[2.6rem] mb-2 mt-3": suffixGreaterThan1
        })
    }, prefix, number ? /*#__PURE__*/ React.createElement("span", {
        ref: nodeRef
    }) : /*#__PURE__*/ React.createElement("span", null, value)) : null, suffix ? /*#__PURE__*/ React.createElement("span", {
        className: clsx("mt-0", {
            "leading-[3rem] mb-0 mx-auto max-w-[190px] lg:max-w-[230px] text-[2.6rem] tracking-widest": suffixGreaterThan1,
            "text-[3.3rem] xxl:text-[4rem]": !suffixGreaterThan1
        })
    }, suffix) : null), /*#__PURE__*/ React.createElement("p", {
        className: "relative mx-auto max-w-4xl pt-6 font-light text-sm lg:text-md leading-sm lg:leading-md"
    }, description));
}
var IconMap = {
    Triangle: /*#__PURE__*/ React.createElement(Triangle, null),
    Diamond: /*#__PURE__*/ React.createElement(Diamond, null),
    Square: /*#__PURE__*/ React.createElement(Square, null),
    Squiggle: /*#__PURE__*/ React.createElement(Squiggle, null)
};
function Squiggle() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center absolute -top-[5px] inset-x-0 lg:right-[unset] lg:top-[12px] lg:left-[12px]"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "109",
        height: "109",
        viewBox: "0 0 109 109",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M51.6337 109C36.7164 109 22.8647 105.716 13.4526 99.948C3.24136 93.6471 -1.46469 84.4177 0.399967 74.3895C1.73186 67.5562 6.26034 58.8592 20.2897 55.7531C28.0147 54.067 36.894 54.422 44.7078 54.7769C49.1475 54.9544 55.6293 55.2206 58.3819 54.6882C59.9802 54.5107 60.069 53.6233 59.2699 52.5583C58.4707 51.6709 55.9845 50.0735 54.2975 49.0085C48.5259 45.2812 39.7354 39.779 37.1604 28.2422C34.4966 16.1729 38.581 6.41098 48.1707 2.15123C64.5974 -5.12585 92.7449 6.76597 107.307 27.1773C110.237 31.2595 109.26 36.9392 105.176 39.779C101.091 42.7076 95.4087 41.7314 92.5673 37.6491C81.4682 22.1188 60.2466 15.3742 55.5405 18.6578C54.6526 19.279 53.3207 20.7876 54.4751 24.3374C55.7182 28.1535 58.9147 30.4608 64.0647 33.6556C68.238 36.318 72.8552 39.2466 75.519 44.305C78.7156 50.4284 78.538 57.9717 73.2104 65.3375C67.2613 73.4133 56.3397 73.4133 43.9974 72.8808C37.2491 72.6146 29.6129 72.3484 24.1965 73.4134C19.4905 74.3895 18.7802 75.9869 18.3362 77.2294C17.981 78.2943 17.5371 81.1341 22.9535 84.4177C29.613 88.4999 40.9785 90.9848 52.6992 90.8073C64.7751 90.6298 75.519 87.79 81.4682 83.1753C85.4638 80.0692 91.1466 80.8679 94.1656 84.7727C97.2733 88.7662 96.4742 94.4458 92.5673 97.4632C87.2397 101.634 74.8974 108.645 52.8767 108.911C52.5216 109 52.0776 109 51.6337 109Z",
        fill: "#FCEA0A"
    })));
}
function Diamond() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center absolute top-0 lg:top-[12px] inset-x-0"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "86",
        height: "101",
        viewBox: "0 0 86 101",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-0.000185619 50.5L85.4998 0.703541L85.4998 100.296L-0.000185619 50.5Z",
        fill: "#FDE900"
    })), /*#__PURE__*/ React.createElement("svg", {
        className: "relative -left-px",
        xmlns: "http://www.w3.org/2000/svg",
        width: "86",
        height: "101",
        viewBox: "0 0 86 101",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M85.9998 50.5L0.49982 100.296L0.499824 0.703537L85.9998 50.5Z",
        fill: "#FDE900"
    })));
}
function Triangle() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center absolute top-0 lg:top-[12px] inset-x-0"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "132",
        height: "112",
        viewBox: "0 0 132 112",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M66 112L0.182062 0.250003L131.818 0.250014L66 112Z",
        fill: "#FDE900"
    })));
}
function Square() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center absolute -top-2 md:-top-1.5 lg:top-[12px] inset-x-0"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "104",
        height: "104",
        viewBox: "0 0 104 104",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "104",
        height: "104",
        fill: "#FDE900"
    })));
}
